// extracted by mini-css-extract-plugin
export default {"Container":"TutorSelection_Container__JUEuO"};